var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_20899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2081 9.70303C18.2081 9.0993 18.1592 8.49233 18.0548 7.89844H9.67773V11.3184H14.4748C14.2758 12.4215 13.6361 13.3972 12.6996 14.0172V16.2363H15.5616C17.2422 14.6894 18.2081 12.4051 18.2081 9.70303Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.67667 18.3824C12.0719 18.3824 14.092 17.596 15.5637 16.2384L12.7018 14.0194C11.9055 14.5611 10.8775 14.8678 9.67991 14.8678C7.36296 14.8678 5.39843 13.3047 4.69355 11.2031H1.74023V13.4907C3.24789 16.4897 6.31869 18.3824 9.67667 18.3824Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.69166 11.2036C4.31964 10.1006 4.31964 8.90622 4.69166 7.80322V5.51562H1.74161C0.481963 8.0251 0.481963 10.9817 1.74161 13.4912L4.69166 11.2036Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.67667 4.13239C10.9429 4.11282 12.1666 4.58926 13.0836 5.46383L15.6192 2.92823C14.0137 1.42056 11.8826 0.591679 9.67667 0.617786C6.31869 0.617786 3.24789 2.51052 1.74023 5.51278L4.69029 7.80038C5.39191 5.69553 7.3597 4.13239 9.67667 4.13239Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_20899"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.e4dce40e3e66a5b5684837792256d245.svg";
export { ForwardRef as ReactComponent };